export const SPEC_COMP_LIST = [
    '宁波美美家园服务有限公司',
    '宁波美美家园电器服务有限公司',
    '宁波美美家园电器公司',
    '宁波美美家园电器有限公司',
    '宁波美美家园电器服务公司',
];

export const NO_TITLE_ADDRESS = [
    '山东因思互联网服务有限公司'
];

// export const NO_OPEN_INFO_COMPANY = [
//     38951, // 百度
//     41633, // 抖音视界有限公司5
//     42870, // 北京巨量引擎网络技术有限公司
// ];

export const VIP_NET_LIST = [{
    // 百度教育客服电话
    companyName: '北京百度网讯科技公司',
    vipPhoneConfig: [{
        netUrl: 'https://ufosdk.baidu.com/bailingPC/getEntryPath/LC5goIPKpyKP8gsHvYtoGCffZf1miu42IxqWb-MbP-U=',
        netPhoneNum: '4008200211',
        newPhoneNum: '在线客服',
        callIcon: 'https://bdhm.cdn.bcebos.com/card/icon-online-net.svg',
    }]
}, {
    // 百度游戏客服电话
    companyName: '北京百度网讯科技',
    vipPhoneConfig: [{
        netUrl: 'https://ufosdk.baidu.com/bailingPC/getEntryPath/Awh4PHUyxZaaHRcRzqpeyotf6AeiYAavnXolKgdMBtY=',
        netPhoneNum: '4009200709',
        newPhoneNum: '在线客服',
        callIcon: 'https://bdhm.cdn.bcebos.com/card/icon-online-net.svg',
    }]
}];